module.exports = "/_next/static/images/d5a52dc85b1d4aa4a7926ae754f73bc9-cajitas-right-mobile.jpg";